import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'ld-bank-linking-error',
  templateUrl: './bank-linking-error.component.html',
  styleUrls: ['./bank-linking-error.component.css']
})
export class BankLinkingErrorComponent {

  @Input() errorCode: string;

  @Output() onManualConnect = new EventEmitter<void>();
  @Output() onRetry = new EventEmitter<void>();

  public get errorMessage(): string {
    if (this.errorCode === '38008') {
      return 'Please try again with a different account or connect your bank information manually.';
    }
    return 'Please try again or connect your bank information manually.';
  }

  public finishTask(): void {
    this.onManualConnect.next();
  }

  public retry(): void {
    this.onRetry.next();
  }

}
